export default __webpack_public_path__ + "static/media/index.js.5807948f.flow";